import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppComponent } from 'src/app/app.component';
import { CyberAttackRecommendationDto } from 'src/app/model/cyber-attack-recommendation-dto';
import { CyberAttackRecommendationsService } from 'src/app/services/cyber-attack-recommendations.service';
import { LoadIndicatorService } from 'src/app/services/load-indicator.service';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-protection-policies',
  templateUrl: './protection-policies.component.html',
  styleUrl: './protection-policies.component.scss',
})
export class ProtectionPoliciesComponent implements OnInit {
  recommendations: CyberAttackRecommendationDto[] = [];

  constructor(
    private cyberAttackRecommendationService: CyberAttackRecommendationsService,
    private toastrService: ToastrService,
    private loadIndicatorService: LoadIndicatorService,
    private dialog: MatDialog,
  ) {
    AppComponent.updateAppHeader('Protection Policies');
  }

  ngOnInit() {
    this.loadIndicatorService.show();
    this.cyberAttackRecommendationService
      .getRecommendations()
      .then((response) => {
        this.recommendations = response;
      })
      .catch((er) => {
        this.toastrService.error(er);
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  askUpdateRecommendation(
    $event: FocusEvent,
    recommendation: CyberAttackRecommendationDto,
  ) {
    const newText = ($event.target as HTMLElement).textContent;

    if (newText == null || newText.length == 0) {
      ($event.target as HTMLElement).textContent =
        recommendation.recommendation;
    }
    if (
      newText != null &&
      newText != recommendation.recommendation &&
      newText?.length > 0
    ) {
      this.dialog
        .open(ConfirmationDialogComponent, {
          data: 'You are going to modify the recommendation, are you sure?',
        })
        .afterClosed()
        .subscribe((response) => {
          if (response) {
            this.updateRecommendation(newText, recommendation);
          } else {
            ($event.target as HTMLElement).textContent =
              recommendation.recommendation;
          }
        });
    }
  }

  updateRecommendation(
    newText: string,
    recommendation: CyberAttackRecommendationDto,
  ) {
    this.loadIndicatorService.show();
    recommendation.recommendation = newText;
    this.cyberAttackRecommendationService
      .updateRecommendation(recommendation)
      .then(() => {
        this.toastrService.success(
          `${recommendation.cyberAttack} successfully updated`,
        );
      })
      .catch((er) => {
        this.toastrService.error(er);
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }
}
